export default __webpack_public_path__ + "static/media/badge-app-store.50c2114e.svg";